import { render, staticRenderFns } from "./FeedbackMain.vue?vue&type=template&id=29c0837a&scoped=true"
import script from "./FeedbackMain.vue?vue&type=script&lang=js"
export * from "./FeedbackMain.vue?vue&type=script&lang=js"
import style0 from "./FeedbackMain.vue?vue&type=style&index=0&id=29c0837a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c0837a",
  null
  
)

export default component.exports